import React from "react";
import { GlobalStateProvider, useGlobalState } from "./GlobalStateProvider";
import Entrance from "./Entrance";
import Title from "./Title";
import Story from "./Story";
import Clear from "./Clear";
import { initAudioContext } from "./SoundEffect";
import StoryVerify from "./StoryVerify";


const StepControlWrapper: React.FC = () => {
  const { currentStep } = useGlobalState();

  initAudioContext();

  window.addEventListener('beforeunload', (e) => {
    //離脱確認ダイアログ
    if (currentStep > 10 && currentStep != 77 && currentStep != 99 && currentStep != 103) {
      e.preventDefault();
      e.returnValue = '';
    }
  });

  return <>
    {currentStep < 10 && <Entrance></Entrance>}
    {currentStep == 10 && <Title></Title>}
    {currentStep > 10 && currentStep != 77 && currentStep != 99 && currentStep < 100 && <Story></Story>}
    {(currentStep == 77 || currentStep == 99 || currentStep == 103) && <Clear></Clear>}
    {currentStep >= 100 && currentStep != 103 && <StoryVerify></StoryVerify>}
  </>;
};

export default StepControlWrapper;
